/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LevelEmailOverride
 */
export interface LevelEmailOverride {
    /**
     * 
     * @type {string}
     * @memberof LevelEmailOverride
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof LevelEmailOverride
     */
    messageTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof LevelEmailOverride
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof LevelEmailOverride
     */
    buttonText?: string;
    /**
     * 
     * @type {string}
     * @memberof LevelEmailOverride
     */
    buttonUrl?: string;
}

/**
 * Check if a given object implements the LevelEmailOverride interface.
 */
export function instanceOfLevelEmailOverride(value: object): value is LevelEmailOverride {
    return true;
}

export function LevelEmailOverrideFromJSON(json: any): LevelEmailOverride {
    return LevelEmailOverrideFromJSONTyped(json, false);
}

export function LevelEmailOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): LevelEmailOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'] == null ? undefined : json['subject'],
        'messageTitle': json['messageTitle'] == null ? undefined : json['messageTitle'],
        'message': json['message'] == null ? undefined : json['message'],
        'buttonText': json['buttonText'] == null ? undefined : json['buttonText'],
        'buttonUrl': json['buttonUrl'] == null ? undefined : json['buttonUrl'],
    };
}

export function LevelEmailOverrideToJSON(json: any): LevelEmailOverride {
    return LevelEmailOverrideToJSONTyped(json, false);
}

export function LevelEmailOverrideToJSONTyped(value?: LevelEmailOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'messageTitle': value['messageTitle'],
        'message': value['message'],
        'buttonText': value['buttonText'],
        'buttonUrl': value['buttonUrl'],
    };
}

